import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import SecureLS from "secure-ls";
import { Toaster } from "sonner";
import { UserProvider } from "./Components/provider/user-id-provider";
import { HelmetProvider } from "react-helmet-async";

const ls = new SecureLS();
axios.defaults.baseURL = "https://webapi.softcodingsolutions.com/api/v1";
// axios.defaults.baseURL = "https://920241f47931.ngrok-free.app/api/v1";

axios.defaults.headers.common["ngrok-skip-browser-warning"] = true;

axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${ls.get("access_token")}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const helmetContext = {};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <HelmetProvider context={helmetContext}>
      <UserProvider>
        <App />
      </UserProvider>
    </HelmetProvider>
    <Toaster position="top-right" expand={false} />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
